module.exports = __webpack_public_path__ + "img/97.b82a63bd.png";